webpackJsonp([59393608157790],{

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _siteInternetResponsive = __webpack_require__(816);
	
	var _siteInternetResponsive2 = _interopRequireDefault(_siteInternetResponsive);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _eMarketing = __webpack_require__(792);
	
	var _eMarketing2 = _interopRequireDefault(_eMarketing);
	
	var _referencementSeoSom = __webpack_require__(813);
	
	var _referencementSeoSom2 = _interopRequireDefault(_referencementSeoSom);
	
	var _RightPicture = __webpack_require__(33);
	
	var _RightPicture2 = _interopRequireDefault(_RightPicture);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _siteDesigne = __webpack_require__(815);
	
	var _siteDesigne2 = _interopRequireDefault(_siteDesigne);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _elasticsearch = __webpack_require__(67);
	
	var _elasticsearch2 = _interopRequireDefault(_elasticsearch);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteInternetApp = function (_Component) {
	  _inherits(SiteInternetApp, _Component);
	
	  function SiteInternetApp() {
	    _classCallCheck(this, SiteInternetApp);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SiteInternetApp.prototype.render = function render() {
	    var goto = "En découvrir plus";
	    var alt = "La vitrine de votre activité Internet";
	    var description = ["Nous réalisons des sites Internet, véritable vitrine de votre activité, sur-mesure et optimisés pour le référencement.", _react2.default.createElement("br", null), "En plus de créer des sites sublimes, nous apportons un soin tout particulier sur l'optimisation et l'ergonomie."];
	    var smalltitle = "Vous avez la main sur votre communication !";
	    var titlemethodo = "Vous êtes autonomes";
	    var descriptionmethodo = ["Nous proposons plusieurs choix à nos clients pour le pilotage de leurs sites internet.", _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Une autonomie totale \xE0 travers un espace d'administration"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Vous souhaitez piloter votre communication de A \xE0 Z, c'est possible !"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Nous nous occupons des mises \xE0 jour pour vous."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Vous n'avez pas le temps, vous ne savez pas faire, on s'occupe de tout !"
	        )
	      )
	    )];
	    var pictureMethodo = _eMarketing2.default;
	    var altmethodo = "Méthodologie agile Scrum en image";
	
	    var smalltitleevol = "Design et Ergonomie font bon ménage";
	    var titleevol = "Une ergonomie réfléchie";
	    var descriptionevol = ["Nous travaillons avec nos graphistes web afin d'", _react2.default.createElement(
	      "strong",
	      null,
	      "imaginer un site vitrine"
	    ), " entièrement à votre image.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nous mettons notre expérience à votre service pour proposer une ergonomie efficace !", _react2.default.createElement("br", null), _react2.default.createElement("br", null), " Toutes les organisations sont différentes, c'est pourquoi nous ne réalisons que des sites Internet sur-mesure !"];
	    var altevol = "Intégration du portail dans votre système d'information";
	
	    var smalltitleCheck = "Le référencement naturel au coeur de votre site";
	    var titleCheck = "On optimise votre site pour le positionnement dans les moteurs de recherche";
	    var subtitle1Check = "Les bonnes pratiques";
	    var text1Check = ["Nous mettons en place l'ensemble des recommandations et bonnes pratiquent du moteur de Recherche de Google pour votre ", _react2.default.createElement(
	      "strong",
	      null,
	      "r\xE9f\xE9rencement naturel"
	    ), "."];
	    var subtitle2Check = "Un site rapide";
	    var text2Check = "Nous développons des sites rapides et compatibles avec les tablettes et smartphones (Responsive). L'optimisation est au coeur de nos réalisations !";
	    var subtitle3Check = "Les conseils";
	    var text3Check = "Au-delà de l'aspect technique, le contenu de votre site est primordial dans le référencement. Nous vous accompagnons et conseillons pour que le contenu de votre site réponde aux critères qualitatifs nécessaires à un référencement de qualité.";
	    var pictureCheck = _referencementSeoSom2.default;
	    var altCheck = "Référencemnent et SEO";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "generic-services" },
	      _react2.default.createElement(_MainPicture2.default, { title: "Cr\xE9ation de site Internet de qualit\xE9", description: description, picture: _siteInternetResponsive2.default, alt: alt }),
	      _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _siteDesigne2.default, alt: altevol }),
	      _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	      _react2.default.createElement(_CheckModule2.default, {
	        smalltitle: smalltitleCheck,
	        title: titleCheck,
	        subtitle1: subtitle1Check,
	        text1: text1Check,
	        subtitle2: subtitle2Check,
	        text2: text2Check,
	        subtitle3: subtitle3Check,
	        text3: text3Check,
	        picture: pictureCheck,
	        alt: altCheck
	      })
	    );
	  };
	
	  return SiteInternetApp;
	}(_react.Component);
	
	exports.default = SiteInternetApp;
	module.exports = exports["default"];

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/e-marketing.099beac4.png";

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/referencement-seo-som.43045758.png";

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/site-designe.d22486fa.png";

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/website.27c2fbd0.jpg";

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteInternetApp = __webpack_require__(295);
	
	var _SiteInternetApp2 = _interopRequireDefault(_SiteInternetApp);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _website = __webpack_require__(840);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteInternet = function (_Component) {
	    _inherits(SiteInternet, _Component);
	
	    function SiteInternet() {
	        _classCallCheck(this, SiteInternet);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SiteInternet.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Création de sites internet exclusifs",
	                "description": "Integral Service vous accompagne dans la création de votre site Internet sur-mesure. Chez nous tout est fait à la main pour que le site réponde à 100% de votre besoin.",
	                "cover": _website2.default
	            }
	        };
	
	        var title = "Site Internet";
	        var description = "Des sites Internet rapides et sublimes";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Cr\xE9ation de site Internet | " + _SiteConfig2.default.siteTitle,
	                description: "Integral Service vous accompagne dans la cr\xE9ation de votre site Internet sur-mesure. Chez nous tout est fait \xE0 la main pour que le site r\xE9ponde \xE0 100% de votre besoin."
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _website2.default }),
	            _react2.default.createElement(_SiteInternetApp2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return SiteInternet;
	}(_react.Component);
	
	exports.default = SiteInternet;
	
	;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-site-internet-jsx-44b95b06ba4e11670f3a.js